import { render, staticRenderFns } from "./RequestArticleModal.vue?vue&type=template&id=5316ab8d&"
import script from "./RequestArticleModal.vue?vue&type=script&lang=js&"
export * from "./RequestArticleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports